import type {ReactElement, ReactNode} from 'react';
import React from 'react';
import {Option} from '@Components/contextual-menu/components/option';
import type {ColorFillPropertyType} from '@Components/color-fill';
import {ColorFill} from '@Components/color-fill';
import type {ColorStorage} from '@Components/color-picker-v2';
import type {RGBA} from '@Utils/color.util';

interface ContextualMenuColorFillOptionProps {
  id: string;
  className?: string;
  label: string;
  data: ColorFillStorage[];
  isDisabled?: boolean;
  children?: ReactNode;

  onClick(id: string): void;
  colorFillHeight?: number;
  colorFillWidth?: number;
}

export interface ColorFillStorage {
  id: string;
  color: ColorStorage[];
  fillType?: ColorFillPropertyType;

  onClick?(): void;
}

const COLOR_FILL_WIDTH = 48;
const COLOR_FILL_HEIGHT = 32;

export function ContextualMenuColorFillOption({
  className = '',
  colorFillWidth = COLOR_FILL_WIDTH,
  colorFillHeight = COLOR_FILL_HEIGHT,
  isDisabled = false,
  children = null,
  ...props
}: ContextualMenuColorFillOptionProps): ReactElement<any> {
  const getColorFillColorArray = (itemColors: ColorStorage[]): RGBA | RGBA[] => {
    if (itemColors.length === 1) {
      return itemColors[0].color;
    }
    const colorsArray: RGBA[] = [];
    for (let index = 0; index < itemColors.length; index += 1) {
      colorsArray.push(itemColors[index].color);
    }
    colorsArray.reverse();
    return colorsArray;
  };

  const getColorFillOptions = (): ReactElement<any>[] => {
    return props.data.map((item, index) => {
      return (
        <ColorFill
          id={item.id}
          key={item.id}
          height={colorFillHeight}
          width={colorFillWidth}
          className={index !== 0 ? 'spacing-m-l-2' : ''}
          color={getColorFillColorArray(item.color)}
          colorFillPropertyType={item.fillType}
          onClick={(): void => {
            if (isDisabled) {
              return;
            }
            props.onClick(item.id);
            if (item.onClick) {
              item.onClick();
            }
          }}
          isDisabled={isDisabled}
        />
      );
    });
  };

  const getColorFillOptionContainer = (): ReactElement<any> => {
    return <div className="flex-row-align-center">{getColorFillOptions()}</div>;
  };

  return <Option key={props.id} label={props.label} className={className} isDisabled={isDisabled} optionControl={getColorFillOptionContainer()} children={children}/>;
}